module.exports = __webpack_public_path__ + "img/ck.d2e12ff.svg";